export default __webpack_public_path__ + "static/media/NEO NX 110_5.29d04deb.webp";